import React from 'react';
import './style.scss';

export const Notification = (props) => {
    let classes;
    if(props.show)
    {
        classes = "notification is-success notify show";
        if(props.error)
        {
            classes = "notification is-danger notify show";
        }
    }else {
        classes = "notification is-success notify";
    }
    
    return (
        <div className={classes}>
            {props.message}
        </div>
    )

} 


// WEBPACK FOOTER //
// ./src/Components/Notification/index.js